import React, { useRef, useState } from 'react';
import { FormatTypes } from '../../../../../../../constants/templateDictionaries';
import titleToSectionKey from '../../../../../../../store/helpers/titleToSectionKeyDict';
import EditorSection from './EditorSection';
import PersonalInfo from './PersonalInfo';

export const getSectionKey = (section) => {
  const { title, sectionKey } = section;
  return sectionKey || titleToSectionKey[title];
};

const ShowResumeSection = (props) => {
  const [isTitleEditing, setTitleEditing] = useState(false);

  const {
    activeElement,
    updateFocusedEditor,
    layout,
    saveDocument,
    setSaveToggler,
    updateEditorRef,
    permission,
    formatType,
    editorRefs,
  } = props;

  const parentRef = useRef();
  if (formatType !== FormatTypes.RESUME) return null;

  const { title: activeElementTitle, sectionKey } = activeElement;

  const orgKey = getSectionKey({ title: activeElementTitle, sectionKey });
  const { statusBarRef, mostUsedToolSetRef } = props;

  switch (orgKey) {
    case 'personalInfo': {
      return (
        <PersonalInfo
          title={activeElementTitle}
          key="personalInfo"
          sectionKey="personalInfo"
          updateFocusedEditor={updateFocusedEditor}
          setSaveToggler={setSaveToggler}
          updateEditorRef={updateEditorRef}
          permission={permission}
          saveDocument={saveDocument}
          formatType={formatType}
          parentRef={parentRef}
          ref={parentRef}
          editorRefs={editorRefs}
          statusBarRef={statusBarRef}
          mostUsedToolSetRef={mostUsedToolSetRef}
        />
      );
    }
    default:
      return (
        <EditorSection
          {...layout}
          title={activeElementTitle}
          sectionKey={orgKey}
          key={orgKey}
          updateFocusedEditor={updateFocusedEditor}
          setSaveToggler={setSaveToggler}
          updateEditorRef={updateEditorRef}
          permission={permission}
          saveDocument={saveDocument}
          formatType={formatType}
          parentRef={parentRef}
          ref={parentRef}
          statusBarRef={statusBarRef}
          mostUsedToolSetRef={mostUsedToolSetRef}
          isTitleEditing={isTitleEditing}
          setTitleEditing={setTitleEditing}
          editor={editorRefs.section}
        />
      );
  }
};
export default ShowResumeSection;
